import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './search-filter-group.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class SearchFilterGroup extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      isClosed: { type: Boolean, reflect: true },
      itemList: { type: Object },
      facetId: { type: String },
    };
  }

  constructor() {
    super();
    this.isClosed = false;
    this.facetId = '';
  }

  toggle() {
    this.isClosed = !this.isClosed;
    this.requestUpdate('isClosed', this.isClosed);
  }

  render() {
    return html`
      <div class="hf-search-filter-group">
        <span @click="${this.toggle}" class="hf-search-filter-group--toggle">
          <h2 class="hf-search-filter-group--title font-sans text-4xl">
            ${this.title}
          </h2>
          <hf-icon
            class="hf-search-filter-group--icon"
            name="${this.isClosed ? 'chevron-down' : 'chevron-up'}"
          >
          </hf-icon>
        </span>
        <ul
          class="${classMap({
            'hf-search-filter-group--items': true,
            'hf-search-filter-group--items--closed': this.isClosed,
          })}"
        >
          ${this.itemList.map(item => {
            return html`
              <li>
                <hf-search-filter-item
                  .facetId="${item.id}"
                  .label="${item.label}"
                  .value="${item.value}"
                  ?isActive="${item.active}"
                >
                </hf-search-filter-item>
              </li>
            `;
          })}
        </ul>
      </div>
    `;
  }
}
customElements.define('hf-search-filter-group', SearchFilterGroup);
